import PropTypes from 'prop-types';

export default PropTypes.shape({
  availability: PropTypes.number,
  code: PropTypes.string,
  highestBucketCodeLogicalAvailability: PropTypes.number,
  passengerType: PropTypes.string,
  physicalAvailability: PropTypes.number,
  price: PropTypes.number
});
